export default {
      id: "arrow-right-usage",
      viewBox: "0 0 41 32",
      url: __webpack_public_path__ + "img/icons.ec9c9113.svg#arrow-right",
      toString: function () {
        return this.url;
      }
    }